<script lang="ts">
	import { LiveDropInfo } from './LiveDropInfo';
	import { createLiveDropInfoContext } from './runes/setLiveDropInfoContext/setLiveDropInfoContext.svelte';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	createLiveDropInfoContext();
</script>

<LiveDropInfo />

{@render children?.()}
